<pathPantalla></pathPantalla>
<div [hidden]="consulta">
  <div class="row">
    <div class="col-lg-12" style="padding: 0px">
      <section class="widget">
        <header>
          <h3> {{sistemaService.NombrePantallaActual}} </h3>
        </header>
        <div class="separador"></div>
      </section>
      <div class="divisor8"></div>
      <div class="row">
        <div class="col-lg-12" style="padding: 0px">
          <section class="widget">

            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                  <dropdownCustom [titulo]="'Periodo de evaluación'" valorName="periodoevaluacionid"
                  displayValor="descripcion" propiedad="periodoevaluacionid"
                  [opciones]="listaperiodoevaluacion" [(ngModel)]="periodoevaluacion"
                  (ngModelChange)="getAcuerdos($event)"></dropdownCustom>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                <button class="boton botonSM filled" *ngIf="periodoevaluacion > 0" (click)="getAcuerdos(entidad.periodoevaluacionid)" matTooltip="Refresca la información en tabla">Actualizar</button>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                <button class="boton botonSM filled" *ngIf="periodoevaluacion > 0" (click)="generarAcuerdos()">Generar acuerdos</button>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-12 col-12" style="padding-right: 0;">
                <button class="boton botonSM filled botonDerecha" *ngIf="periodoevaluacion > 0" [disabled]="!sistemaService.permisos.eliminar" (click)="EliminarAcuerdoGeneral()">Eliminar todos los acuerdos</button>
              </div>
          </div>

            <dx-data-grid (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)" id="tabla"
              [columnAutoWidth]="true" [dataSource]="SelColaborador" [noDataText]="'Sin Datos'"
              [hoverStateEnabled]="true" [showColumnHeaders]="true" (onRowPrepared)="onRowPrepared($event)">
              <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual"
                *ngIf="sistemaService.permisos.exportar"></dxo-export>

              <dxo-search-panel [visible]="true" [width]="240" placeholder="{{'Buscar' | translate}}">
              </dxo-search-panel>

              <dxo-paging [pageSize]="50"></dxo-paging>
              <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->
              <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>

              <dxo-pager [visible]="true" [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                [displayMode]="sistemaService.tablaPaginacionModo" [showInfo]="sistemaService.tablaPaginacionInfo"
                [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
              </dxo-pager>
              <dxi-column cellTemplate="cellViewStatus" caption="Estatus" [allowEditing]="false"
                alignment="center" [width]="150">

              </dxi-column>
              <dxi-column [allowEditing]="false" dataField="nombresubordinado" [groupIndex]="0"
                groupCellTemplate="groupCellTemplateColaborador" [autoExpandGroup]="true">
              </dxi-column>
              <dxi-column [allowEditing]="false" dataField="puestosubordinado" caption="Puesto">
              </dxi-column>
              <dxi-column [allowEditing]="false" dataField="departamentosubordinado" caption="Departamento">
              </dxi-column>
              <dxi-column [allowEditing]="false" dataField="materia" caption="Materia o taller">
              </dxi-column>
              <dxi-column [allowEditing]="false" dataField="nombre" caption="Jefe">
              </dxi-column>
              <dxi-column [allowEditing]="false" dataField="puesto" caption="Puesto del jefe">
              </dxi-column>
              <dxi-column [allowEditing]="false" dataField="reponsable" caption="Jefe responsable del acuerdo">
              </dxi-column>
              <dxi-column
              [allowExporting]="false"
              [allowEditing]="false"
              caption="Acciones"
              cellTemplate="cellAcciones"
              alignment="center"
              [minWidth]="120">

          </dxi-column>
              <!-- Acciones -->
              <div *dxTemplate="let cell of 'cellAcciones'">
                <a matTooltip="Eliminar Acuerdo" class="tablaBoton separado delete" (click)="EliminarAcuerdo(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                    <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                </a>
              </div>
              <div *dxTemplate="let cell of 'cellViewStatus'">
                <span *ngIf="cell.data.activo">Activo</span>
                <span *ngIf="!cell.data.activo">Desactivado</span>
              </div>
              <div *dxTemplate="let cellInfocolaborador of 'groupCellTemplateColaborador'">
                <div class="accionEncabezado">
                  <div class="accionEncabezado__titulo">
                    {{cellInfocolaborador.value}}
                  </div>
                  <div class="accionEncabezado__accionesintermedio">
                    <span>{{cellInfocolaborador.data.total}} relaciones jefe - subordinado</span>
                  </div>
                  <div class="accionEncabezado__acciones">
                    <span>{{cellInfocolaborador.data.texto}}</span>
                    <a matTooltip="Eliminar grupo de acuerdos" class="tablaBoton separado delete" (click)="EliminarGrupoAcuerdo(cellInfocolaborador.data)" *ngIf="sistemaService.permisos.eliminar">
                      <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                  </a>
                  </div>

                </div>
              </div>
            </dx-data-grid>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
